




import { pageFactory } from '@/main/pages/pageFactory';
import { pageStoreBuilder } from '@/main/store/pages/page/builder';

const name = 'NabidkyListIframe';

export default pageFactory(name, pageStoreBuilder({
	name,
	crumbLabel: 'NV_Nabidky',
	dropdownList: {},
	localState: {},
	props: {
		mode: null,
	},
}));
